import { globalLoginInit, globalLogoutInit } from '@forchange/py-tools';

const bootstrap = () => {
  globalLoginInit();
  globalLogoutInit();
};

export default bootstrap;
